import { Link } from '@tanstack/react-router';
import React from 'react';

import SiteLogo from '@/components/site-logo';
import { useInstance } from '@/stores/instance';

const SiteTitle: React.FC = () => {
  const instance = useInstance();

  return (
    <Link to='/' className='site-title'>
      <SiteLogo />
      <h1>{instance.title}</h1>
    </Link>
  );
};

export { SiteTitle as default };
